export default "__VITE_ASSET__DL5HgGBg__"